import { Grid, TextField } from "@material-ui/core";
import React, { useState, useEffect } from "react";
function BuoyForm(props) {
  const [FID, setFID] = useState("");
  const [Shape, setShape] = useState("");
  const [FLASHING, setFLASHING] = useState("");
  const [LICOLOR, setLICOLOR] = useState("");
  const [NUMBER, setNUMBER] = useState("");
  const [NAME, setNAME] = useState("");
  const [TYPE, setTYPE] = useState("");
  const [COLOR, setCOLOR] = useState("");
  const [CODE, setCODE] = useState("");
  useEffect(() => {
    let data = {
      FID: FID,
      Shape: Shape,
      FLASHING: FLASHING,
      LICOLOR: LICOLOR,
      NUMBER: NUMBER,
      NAME: NAME,
      TYPE: TYPE,
      COLOR: COLOR,
      CODE: CODE,
    };
    props.setData(data);
  }, [FID, Shape, FLASHING, LICOLOR, NUMBER, NAME, TYPE, COLOR, CODE]);
  return (
    <>
      <Grid container direction="row" spacing={1}>
        <Grid item md>
          <TextField
            margin="dense"
            value={FID}
            onChange={(e) => setFID(e.target.value)}
            variant="outlined"
            label="FID"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item md>
          <TextField
            margin="dense"
            value={Shape}
            onChange={(e) => setShape(e.target.value)}
            variant="outlined"
            label="Shape"
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item md>
          <TextField
            margin="dense"
            value={FLASHING}
            onChange={(e) => setFLASHING(e.target.value)}
            variant="outlined"
            label="FLASHING"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item md>
          <TextField
            margin="dense"
            value={LICOLOR}
            onChange={(e) => setLICOLOR(e.target.value)}
            variant="outlined"
            label="LICOLOR"
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item md>
          <TextField
            margin="dense"
            value={NUMBER}
            onChange={(e) => setNUMBER(e.target.value)}
            variant="outlined"
            label="NUMBER"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item md>
          <TextField
            margin="dense"
            value={NAME}
            onChange={(e) => setNAME(e.target.value)}
            variant="outlined"
            label="NAME"
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item md>
          <TextField
            margin="dense"
            value={TYPE}
            onChange={(e) => setTYPE(e.target.value)}
            variant="outlined"
            label="TYPE"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item md>
          <TextField
            margin="dense"
            value={COLOR}
            onChange={(e) => setCOLOR(e.target.value)}
            variant="outlined"
            label="COLOR"
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item md>
          <TextField
            margin="dense"
            value={CODE}
            onChange={(e) => setCODE(e.target.value)}
            variant="outlined"
            label="CODE"
            size="small"
          />
        </Grid>
      </Grid>
    </>
  );
}

export default BuoyForm;
